<template>
  <div id="nova" class="min-h-screen dark:bg-surface-dark">
    <MainHeader />

    <div
      dusk="content"
      class="dark:bg-surface-dark pt-[calc(var(--mobile-nav-total)+1rem)] md:pt-24"
    >
      <div
        class="mx-auto w-full min-w-0 max-w-7xl space-y-8 overflow-x-hidden px-4 pb-8 md:px-8 md:py-2 lg:px-10"
      >
        <Breadcrumbs v-if="breadcrumbsEnabled" class="min-w-0" />

        <FadeTransition>
          <slot />
        </FadeTransition>

        <Footer />
      </div>
    </div>

    <PWAInstallPrompt />
    <PWAUpdatePrompt />
    <LogoutConfirmModal />
    <FormAbandonConfirmModal />
  </div>
</template>

<script>
import MainHeader from '@/layouts/MainHeader'
import Footer from '@/layouts/Footer'
import PWAInstallPrompt from '@/components/PWAInstallPrompt'
import PWAUpdatePrompt from '@/components/PWAUpdatePrompt'
import LogoutConfirmModal from '@/components/Modals/LogoutConfirmModal'
import FormAbandonConfirmModal from '@/components/Modals/FormAbandonConfirmModal'

export default {
  components: {
    MainHeader,
    Footer,
    PWAInstallPrompt,
    PWAUpdatePrompt,
    LogoutConfirmModal,
    FormAbandonConfirmModal,
  },

  mounted() {
    Nova.$on('error', this.handleError)
    Nova.$on('token-expired', this.handleTokenExpired)
  },

  beforeUnmount() {
    Nova.$off('error', this.handleError)
    Nova.$off('token-expired', this.handleTokenExpired)
  },

  methods: {
    handleError(message) {
      Nova.error(message)
    },

    handleTokenExpired() {
      Nova.$toasted.show(this.__('Sorry, your session has expired.'), {
        action: {
          onClick: () => Nova.redirectToLogin(),
          text: this.__('Reload'),
        },
        duration: null,
        type: 'error',
      })

      setTimeout(() => {
        Nova.redirectToLogin()
      }, 5000)
    },
  },

  computed: {
    breadcrumbsEnabled() {
      return Nova.config('breadcrumbsEnabled')
    },
  },
}
</script>
